import { z } from 'zod';

export const courseEmailFormSchema = z.object({
    subject: z.string().min(1, 'Subject is required'),
    body: z.string().min(1, 'Body is required'),
});

export type CourseEmailFormData = z.infer<typeof courseEmailFormSchema>;
